(() => {
  const pickerBaseUrl = document.body.dataset.wishlistPickerUrl;
  if (!pickerBaseUrl) return;

  let activeButton;
  let dialog;
  let frame;

  const buildDialog = () => {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'wishlist-modal';
    dialog.setAttribute('aria-labelledby', 'WishlistModalTitle');
    dialog.innerHTML = `<div class="wishlist-modal__panel"><div class="wishlist-modal__top"><h2 id="WishlistModalTitle">Choisir une wishlist</h2><button type="button" class="wishlist-modal__close" aria-label="Fermer">×</button></div><iframe class="wishlist-modal__frame" title="Choisir ou creer une wishlist"></iframe><a class="wishlist-modal__fallback" target="_blank" rel="noopener">Ouvrir dans l'espace membre</a></div>`;
    document.body.append(dialog);
    frame = dialog.querySelector('.wishlist-modal__frame');
    dialog.querySelector('.wishlist-modal__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  };

  const openPicker = (button) => {
    buildDialog();
    activeButton = button;
    const url = new URL(pickerBaseUrl);
    ['productId', 'variantId', 'handle', 'title', 'variant', 'image', 'priceCents', 'currency'].forEach((key) => {
      const value = button.dataset[`wishlist${key.charAt(0).toUpperCase()}${key.slice(1)}`];
      if (value) url.searchParams.set(key, value);
    });
    frame.src = url.toString();
    dialog.querySelector('.wishlist-modal__fallback').href = url.toString();
    dialog.showModal();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.wishlist-card-button');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    openPicker(button);
  });

  window.addEventListener('message', (event) => {
    if (event.origin !== new URL(pickerBaseUrl).origin || event.data?.type !== 'shapers:wishlist-saved') return;
    if (activeButton) {
      activeButton.setAttribute('aria-pressed', 'true');
      activeButton.setAttribute('title', `Ajoute a ${event.data.wishlistName}`);
    }
    window.setTimeout(() => dialog?.close(), 700);
  });
})();
